export default __webpack_public_path__ + "resources/icons/d142-76d5.png";